import type { FC } from 'react'
import SwipeableDrawer, { type SwipeableDrawerProps } from '@mui/material/SwipeableDrawer'

const BaseBottomDrawer: FC<SwipeableDrawerProps> = ({ children, ...props }) => (
  <SwipeableDrawer disableSwipeToOpen disableDiscovery {...props}>
    <div className="px-6 max-h-[90dvh] overflow-y-auto">
      <div className="bg-ink-400 w-[40px] h-[8px] rounded-[10px] absolute top-[8px] left-[calc(50%-20px)]" />
      <div className="flex items-center mt-8">{children}</div>
    </div>
  </SwipeableDrawer>
)

export default BaseBottomDrawer
